export const MAP_LITE_THRESHOLD = 500000;

export const ARR_THRESHOLD_MULTIPLIER = 0.2;

export const AWS_ACCOUNT_ID_DEFAULT = "000000000000";